import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal, MaskedLines } from "../components/motion";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { POSTS } from "../data/blog";
import { url, breadcrumbSchema } from "../data/site";

const trail = [["Home", "/"], ["Resources", "/blog"]];

export default function Blog() {
  const itemList = {
    "@context": "https://schema.org", "@type": "ItemList", name: "ABSLpay payroll resources",
    itemListElement: POSTS.map((p, i) => ({ "@type": "ListItem", position: i + 1, name: p.title, url: url(`/blog/${p.slug}`) })),
  };

  return (
    <>
      <Seo
        title="Payroll Tax Insights & Compliance Guides | ABSLpay Resources"
        description="Expert guides on payroll tax deadlines, multi-state payroll registration, 1099 vs W-2 classification and the FICA tip credit — written by the ABSLpay CPA team."
        path="/blog"
        jsonLd={[itemList, breadcrumbSchema(trail)]}
      />
      <Breadcrumbs trail={trail} />

      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,#ECFDF5_0%,transparent_50%)]" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-16 lg:pt-16 lg:pb-24">
          <MaskedLines
            lines={["Payroll insights from", "the CPA's desk"]}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-slate-900"
          />
          <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-slate-600">
            Practical guides on payroll tax, multi-state compliance and worker classification — written by the team that
            files these returns every quarter.
          </p>

          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
            {POSTS.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.08}>
                <Link
                  to={`/blog/${p.slug}`}
                  data-testid={`blog-card-${p.slug}`}
                  className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:border-emerald-400 hover:-translate-y-1"
                >
                  <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.15em]">
                    <span className="text-emerald-700">{p.category}</span>
                    <span className="text-slate-300">&middot;</span>
                    <span className="text-slate-400">{p.readTime}</span>
                  </div>
                  <h2 className="mt-4 font-display text-xl font-bold leading-snug text-slate-900 group-hover:text-emerald-800 transition-colors">
                    {p.title}
                  </h2>
                  <p className="mt-3 text-sm leading-relaxed text-slate-600 flex-1">{p.description}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-emerald-700">
                    Read the guide <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
